export * from '../shared/lib/app-dynamic'
export { default } from '../shared/lib/app-dynamic'
